import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TpETLComponentTypeManifest } from '../interfaces';
import { TpETLObjectTypes } from '../../etl-data-types/interfaces';
import { TpETLPipelineComponent, TpETLDryRun, TpETLDryRunComponentResult } from '../../interfaces';
import { createConfigParamTypeExistingColumnList } from '../utils';
import { addDryRunObjectTable, getETLComponentInputObjectTable } from '../../utils';
import { addETLDryRunError } from '../../etlDryRun';

function performDryRun(dryRun: TpETLDryRun, comp: TpETLPipelineComponent): TpETLDryRunComponentResult {
  const inputTableObj = getETLComponentInputObjectTable(dryRun, comp, 'sourceTable');
  const outputTableObj = addDryRunObjectTable(dryRun, comp.outputObjectIds['result'], comp);
  const colIdList = (comp.params['columnIds'] || []) as string[];
  if (colIdList.length === inputTableObj.columns.length) {
    addETLDryRunError(dryRun, 'You cannot remove all columns from the table.', comp.id, 'columnIds');
  } else {
    outputTableObj.columns = inputTableObj.columns.filter((col) => !colIdList.includes(col.identifier));
  }

  return {
    abort: false,
  };
}

export const manifestETLTableDropColumns: TpETLComponentTypeManifest = {
  id: 'TableDropColumns',
  name: 'Drop Columns',
  description: 'Removes specified columns from the table',
  categoryId: 'table',
  icon: <FontAwesomeIcon icon={['fas', 'scissors']} />,
  inputs: [
    {
      type: TpETLObjectTypes.TABLE,
      id: 'sourceTable',
      name: 'Source Table',
      columns: [],
    },
  ],
  outputs: [
    {
      id: 'result',
      name: 'Result table',
      type: TpETLObjectTypes.TABLE,
      description: 'Table with removed columns',
      columns: [],
    },
  ],
  params: [
    {
      id: 'columnIds',
      name: 'Column(s) to remove',
      description: 'Column(s) to be removed from the source table.',
      paramType: createConfigParamTypeExistingColumnList('sourceTable'),
    },
  ],
  performDryRun,
};
